import React, { useEffect, useState } from 'react';
import { Box, Flex, Link, Stack, Skeleton } from '@chakra-ui/react';
import { v4 as uuidv4 } from 'uuid';

import ActiveTransfers from '../components/ActiveTransfers';
import { Button, Text, TransferHistory } from '../components';
import { fetchTransferSummaries } from '../api/accounts';

export const { REACT_APP_PALM_HOSTNAME: palmHostname = 'palm.io' } = process.env;
const tokenTransferUrl = `https://app.${palmHostname}/bridge`;

const Home = ({ address }) => {
  const [transferSummaries, setTransferSummaries] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadTransferSummaries = async () => {
    try {
      setLoading(true);
      const transferSummaries = await fetchTransferSummaries({ address });
      setTransferSummaries(transferSummaries);
    } finally {
      setLoading(false);
    }
  };

  useEffect(async () => {
    try {
      if (address) {
        await loadTransferSummaries();
      }
    } catch (e) {
      console.warn('Failed to load transfer summaries', e);
    }
  }, [address]);

  return (
    <Box>
      <Flex mb="60px">
        <Text d="flex" as="h1" textStyle="h1">Your&nbsp;</Text>
        <Text textStyle="h1" as="h1" style={{ fontWeight: 'bold' }}>Transfers</Text>
      </Flex>
      {loading ? (
        <Box width="100%">
          <Skeleton height={['32px', '32px', '48px']} width={['75%', '75%', '25%']} mb={['24px', '24px', '48px']} />
          <Stack>
            {Array(6).fill().map(() => (<Skeleton height={['32px', '32px', '64px']} key={uuidv4()} />))}
          </Stack>
        </Box>
      ) : !transferSummaries.length || !address ? (
        <Flex
          direction="column"
          alignItems="center"
          textAlign="center"
          mt={['48px', '192px', '192px', '192px', '192px']}
        >
          <Box width={['80%', '80%', '80%', '80%', '80%', '50%']}>
            <Text textStyle="h4" style={{ color: 'grey2' }}>
              {address ? 'You don\'t have any transactions' : 'Please select an address to get started'}
            </Text>
            {!address ? null : (
              <>
                <Text textStyle="body2" style={{ color: 'grey4' }} mt="48px">
                  Use this screen to monitor transfer progress on your active transactions
                  and review your transaction history. Come back when you have created at
                  least one transaction.
                </Text>
                <Link href={tokenTransferUrl}>
                  <Button
                    mt="48px"
                    w="180px"
                    h="48px"
                    fontWeight="300"
                    borderRadius={0}
                    _hover={{ opacity: 1, bgColor: 'richBlack' }}
                  >
                    Transfer tokens
                  </Button>
                </Link>
              </>
            )}
          </Box>
        </Flex>
      ) : (
        <>
          <ActiveTransfers address={address} />
          <TransferHistory mt="30px" address={address} />
        </>
      )}
    </Box>
  );
};

export default Home;
